import React from 'react';
interface SectionTitleProps {
  children: React.ReactNode;
  light?: boolean;
  align?: 'center' | 'left';
}
export function SectionTitle({
  children,
  light = false,
  align = 'center'
}: SectionTitleProps) {
  return <div className={align === 'center' ? 'text-center' : ''} data-id="element-242" data-mp="3vw8odsuphf3k">
      <h2 className={`font-serif text-xl font-extrabold uppercase leading-tight sm:text-3xl ${light ? 'text-white' : 'text-brand-sage'}`} data-id="element-243" data-mp="4qh2x6rviqn3">
        {children}
      </h2>
      <span className={`mt-2 block h-0.5 w-14 bg-brand-gold ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-244" data-mp="3qygzl7pcy93l" />
    </div>;
}